import { render, staticRenderFns } from "./SendGroupRemitterEmail.vue?vue&type=template&id=68106100"
import script from "./SendGroupRemitterEmail.vue?vue&type=script&lang=js"
export * from "./SendGroupRemitterEmail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports